<template>
  <div>
    <form class="pl-3">
      <div class="d-flex justify-content-between">
        <h6 class="mt-3 mb-3 text-secondary fw-300">
          {{ $t("user.header_sub_restriction_add", { user: username }) }}
        </h6>
        <div>
          <b-button
            size="sm"
            :variant="hasChecked ? 'primary' : 'secondary'"
            :disabled="!hasChecked"
            @click="resetPermission(userID)"
            >Reset</b-button
          >
        </div>
      </div>
      <div
        v-for="o in permissionList"
        :key="o.id"
        class="custom-control custom-switch mt-2 mb-2"
      >
        <div class="d-flex">
          <input
            type="checkbox"
            class="custom-control-input"
            :id="'permissionList_' + o.id"
            v-model="o.check"
            @input="editPermission(o)"
          />
          <label
            class="custom-control-label fw-500 col-10"
            :for="'permissionList_' + o.id"
          >
            <div class="row fs-md d-flex justify-content-between">
              <div class="col-1 text-center pr-0">
                <i class="fas" :class="o.icon"></i>
              </div>
              <div class="col-10 pl-0">{{ o.text }}</div>
            </div>
          </label>
          <div class="col-2 d-flex justify-content-end">
            <i
              v-if="o.id == 4 && o.check && !checked"
              @click.stop="checked = true"
              class="fal fa-chevron-down fs-xl"
            ></i>
            <i
              v-if="o.id == 4 && o.check && checked"
              @click.stop="checked = false"
              class="fal fa-chevron-up fs-xl"
            ></i>
          </div>
        </div>
        <template v-if="o.id == 4 && o.check">
          <b-collapse
            id="collapsePermission"
            class="border my-2"
            v-model="checked"
          >
            <b-table-simple>
              <b-thead>
                <b-tr>
                  <b-th>#</b-th>
                  <b-th>Username</b-th>
                  <b-th>Business Name</b-th>
                  <!-- <b-th>Location</b-th>
                  <b-th>City</b-th>
                  <b-th>Contact</b-th> -->
                  <b-th
                    ><b-button
                      size="sm"
                      :variant="hasCheckedOutlet ? 'primary' : 'secondary'"
                      :disabled="!hasCheckedOutlet"
                      @click="resetOutletPermission(userID)"
                      >Reset</b-button
                    ></b-th
                  >
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="(v, index) in outletList" :key="v.id">
                  <b-td>{{ index + 1 }}</b-td>
                  <b-td>{{ v.loyalty.username }}</b-td>
                  <b-td>{{ v.bizName !== "" ? v.bizName : "-" }}</b-td>
                  <!-- <b-td>{{ v.map.location }}</b-td>
                  <b-td>{{ v.map.city }}</b-td>
                  <b-td>{{ v.contact.telephone }}</b-td> -->
                  <b-td>
                    <b-form-checkbox
                      v-model="v.enable"
                      name="check-button"
                      switch
                      @input="editOutletPermission(v)"
                    >
                    </b-form-checkbox>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-collapse>
        </template>
      </div>
    </form>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import {
  handleSessionExpired,
  getBreadCrumbs,
} from "./../../../../assets/js/dashboard/dashboard";
export default {
  name: "userPermissionForm",
  props: {
    permissionType: { type: Array },
    userID: { type: Number },
    username: { type: String },
  },
  data() {
    return {
      permissionList: [],
      selectedPermission: {},
      outletList: [],
      checked: false,
    };
  },
  computed: {
    hasChecked() {
      let flag = false;
      this.permissionList.forEach((element) => {
        if (element.check) flag = true;
      });
      return flag;
    },
    hasCheckedOutlet() {
      let flag = false;
      this.outletList.forEach((element) => {
        if (element.enable) flag = true;
      });
      return flag;
    },
    hasPermission() {
      var ret = {};
      for (var i = 0; i < this.permissionType.length; i++) {
        for (var j = 0; j < this.permissionList.length; j++) {
          if (
            this.permissionList[j].id == this.permissionType[i].permissionTypeID
          ) {
            ret[this.permissionList[j].id] = true;
          } else {
            ret[this.permissionList[j].id] = false;
          }
        }
      }

      return ret;
    },
  },
  methods: {
    async resetPermission(id) {
      let result = [];
      let url =
        this.$api.API_ENDPOINT_BEBUSINESS +
        "/users/" +
        id +
        "/permission/reset";
      await this.$axios({
        method: "post",
        url: url,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      if (result.status == 200) {
        this.permissionList.forEach((e) => {
          e.check = false;
        });
        this.toastrExe("Permission", "Permissions have been reset.", "success");
        this.$emit("updateList");
      } else {
        this.toastrExe("Permission", "Error.", "danger");
      }
    },
    async resetOutletPermission(id) {
      let result = [];
      let url =
        this.$api.API_ENDPOINT_BEBUSINESS + "/users/" + id + "/outlet/reset";
      await this.$axios({
        method: "post",
        url: url,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      if (result.status == 200) {
        this.outletList.forEach((e) => {
          e.enable = false;
        });
        this.toastrExe(
          "Outlet Restrictions",
          "Restrictions have been reset.",
          "success"
        );
      } else {
        this.toastrExe("Outlet Restrictions", "Error.", "danger");
      }
    },
    toastrExe(title, body, variant) {
      this.$bvToast.toast(body, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
    closeModal(isError) {
      if (!isError) {
        this.$emit("resetPermissionList");
      }
      this.$parent.$parent.$parent.$parent.isModalShow = false;
    },
    selectPermission(item) {
      this.selectPermission = item;
    },
    async setPermissionList() {
      var result = await this.getPermissionList();
      this.outletList = await this.getOutletList();
      for (var i = 0; i < result.length; i++) {
        result[i]["breadCrumbs"] = getBreadCrumbs(this, result[i].permission);
      }
      this.permissionList = [];
      for (var j = 0; j < result.length; j++) {
        if (result[j].permission.indexOf("biz") != -1) {
          this.permissionList.push({
            id: result[j].permissionID,
            text: result[j].display,
            icon: result[j].breadCrumbs.icon,
            title: result[j].permission,
            check: this.permitted(result[j].permissionID),
          });
        }
      }
    },
    async getOutletList() {
      let $vm = this;
      var outlets = [];
      var outletPerm = [];
      let url =
        this.$api.API_ENDPOINT_BEBUSINESS +
        this.$api.USERS +
        "/" +
        this.userID +
        "/outlet";
      await $vm.$axios
        .get(url, { headers: { token: $vm.$store.state.token } })
        .then(function (response) {
          outletPerm = response.data;
        });
      url = this.$api.BEBUSINESS_OUTLET;

      await $vm.$axios
        .get(url, { headers: { token: $vm.$store.state.token } })
        .then(function (response) {
          outlets = response.data;
          outlets.forEach((element) => {
            outletPerm.forEach((o) => {
              if (o.outletID == element.outletID) element.enable = true;
            });
          });
          outlets.sort((a, b) => a.id - b.id);
        });
      return outlets;
    },
    permitted(id) {
      let flag = false;
      this.permissionType.forEach((element) => {
        if (element.permissionID == id){
          flag = true;
          if(id == 4)
          this.checked = true;
        }
      });
      return flag;
    },
    getNavObjText(item) {
      var permissionTitle = item.title + " > ";
      for (var i = 0; i < item.subMenu.length; i++) {
        if (i == item.subMenu.length - 1) {
          permissionTitle += item.subMenu[i].text;
        } else {
          permissionTitle += item.subMenu[i].text + " > ";
        }
      }
      return permissionTitle;
    },
    async getPermissionList() {
      let $vm = this;
      var result = [];
      let url = "/security/permission";
      await $vm
        .$axios({
          method: "get",
          url: url,
          baseURL: $vm.$api.API_ENDPOINT_BEBUSINESS,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response.data.permissions;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      return result;
    },
    editPermission(element) {
      let $vm = this;
      let url = "";
      console.log(element);
      if(element.id === 4)
      this.checked = !element.check
      var data = [];
      if (!element.check) {
        url = "/users/" + this.userID + "/permission";
      } else {
        url = `${this.$api.API_ENDPOINT_BEBUSINESS}${this.$api.USERS}/${this.userID}/permission/${element.id}/delete`;
      }
      $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: this.$api.API_ENDPOINT_BEBUSINESS,
          headers: { token: $vm.$session.get("token") },
          data: {
            permissionID: element.id,
          },
        })
        .then(function (response) {
          data = response.data;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      this.$emit("updateList");
    },
    editOutletPermission(element) { 
      let $vm = this;
      let url = "";

      var data = [];
      if (element.enable) {
        url = "/users/" + this.userID + "/outlet";
      }
      else{
        url =
          "/users/" + this.userID + "/outlet/" + element.outletID + "/delete";
      }
      $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: this.$api.API_ENDPOINT_BEBUSINESS,
          headers: { token: $vm.$session.get("token") },
          data: {
            outletID: element.outletID,
          },
        })
        .then(function (response) {
          data = response.data;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
    },
  },
};
</script>
<style>
.b-toaster{
  z-index: 9999 !important;
}
</style>